import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import initShortcuts from './handler';
import config from './adg3/shortcut-definition';
import disableDefaults from './adg3/disable-defaults';
import { doInsertDefaultTable, doPublish, doPreview, buildFormatFunction } from './actions';

export function confluenceKeyboardShortcuts() {
	//
	//  Hookin point for all editor shortcuts,
	//  - handler.js, trigger logic to match user shortcut combos with defined combos
	//  - adg3/shortcut-definition.js, new keyboard shortcut combos for adg3 should be declared here
	//  - adg3/disable-defaults.js, used to override and disable default tinymce shortcuts.
	//
	//  New shortcut profiles should be created in a new folder eg: foo/shortcut-definitions.js, foo/disable-defaults.js
	//
	const plugger = () => {
		return {
			init: (ed) => {
				if (process.env.NODE_ENV !== 'production') {
					console.debug('Init Editor Keyboard shortcuts plugin');
				}

				for (let i = 1; i < 7; i++) {
					ed.addCommand(`FormatBlock-h${i}`, buildFormatFunction(ed, `h${i}`));
				}
				ed.addCommand('FormatBlock-p', buildFormatFunction(ed, 'p'));
				ed.addCommand('FormatBlock-pre', buildFormatFunction(ed, 'pre'));
				ed.addCommand('FormatBlock-blockquote', buildFormatFunction(ed, 'blockquote'));
				ed.addCommand('mceConfShortcutDialog', window.Confluence.KeyboardShortcuts.openDialog);
				ed.addCommand('preventDefaultSave', () => {
					/*intentionally do nothing*/
				});
				ed.addCommand('publish', doPublish);
				ed.addCommand('preview', doPreview);
				ed.addCommand('confDefaultTable', doInsertDefaultTable);

				ed.addButton('help', {
					title: 'confluence.conf_shortcuts_help_desc',
					cmd: 'mceConfShortcutDialog',
				});

				const metatag = window.document.createElement('meta');
				const head = window.document.querySelector('head');
				metatag.setAttribute('name', 'ajs-use-keyboard-shortcuts');
				metatag.setAttribute('content', 'true');
				head.appendChild(metatag);

				// ADG3 UX shortcuts, this overrides existing shortcuts
				bind('rte-ready', () => {
					// disable defaults
					disableDefaults(ed);
					// setup custom keyboard shortcuts
					initShortcuts(ed, config);
				});
			},

			getInfo: (/*ed*/) => {
				return {
					longname: 'Atlassian Editor Keyboard Shortcuts Plugin',
					author: 'Atlassian',
					authorurl: 'http://www.atlassian.com',
					version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
				};
			},
		};
	};

	window.tinymce.create('tinymce.plugins.KeyboardShortcutsPlugin', plugger());
	window.tinymce.PluginManager.add(
		'keyboardshortcuts',
		window.tinymce.plugins.KeyboardShortcutsPlugin,
	);
}

export function confluenceKeyboardShortcutsWRM() {
	return ['wr!com.atlassian.confluence.keyboardshortcuts:confluence-keyboard-shortcuts'];
}
